import { useState, useEffect } from 'react'
import styles from './OfflineBanner.module.css'

export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine)
  const [visible, setVisible] = useState(!navigator.onLine)

  useEffect(() => {
    const handleOffline = () => { setOffline(true); setVisible(true) }
    const handleOnline = () => {
      setOffline(false)
      setTimeout(() => setVisible(false), 1500)
    }
    window.addEventListener('offline', handleOffline)
    window.addEventListener('online', handleOnline)
    return () => {
      window.removeEventListener('offline', handleOffline)
      window.removeEventListener('online', handleOnline)
    }
  }, [])

  if (!visible) return null

  return (
    <div
      className={[styles.banner, offline ? styles.offline : styles.online].join(' ')}
      role="status"
      aria-live="polite"
    >
      {offline
        ? 'Sin conexión. Verifica tu internet para continuar.'
        : '✓ Conexión restaurada.'}
    </div>
  )
}
